<template>
    <section class="lymphomap_main">
        <div class="bot_tickets_table">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col">
                        <h2 class="main_heading">
                            <button type="button" class="btn back_btn" tapable @click="$router.go(-1)">
                                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                            </button>Bot Tickets
                        </h2>
                    </div>
                </div>
                <div class="bot_tickets_list mt-3 pt-1 table-responsive">
                    <table class="table" v-if="botTickets">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Ticket Number</th>
                                <!-- <th>Title</th> -->
                                <th>Category</th>
                                <th>Created Date</th>
                                <th>status</th>
                                <th class="text-right">Action</th>
                            </tr>
                        </thead>
                        <tbody v-if="botTicketResults.length > 0">
                            <tr v-for="(item, index) in botTicketResults" :key="index">
                                <td>{{ item.user_info.full_name }} </td>
                                <td>{{ item.ticket_number }}</td>
                                <!-- <td>{{ item.title }}</td> -->
                                <td style="text-transform: capitalize;">{{ item.category }}</td>
                                <td>{{ item.created_at | LocalDateFormat }} at {{ item.created_at | LocalTimeFormat }}
                                </td>
                                <td>
                                    <label class="badge badge-success" v-if="item.status == 'active'">Active</label>
                                    <label class="badge badge-success" v-else-if="item.status == 'in_progress'">Active</label>
                                    <label class="badge badge-danger" v-else>{{
                                            item.status }}</label>
                                </td>
                                <td class="text-right">
                                    <template v-if="item.status == 'closed'">
                                       <label class="badge badge-secondary">{{ item.last_message_preview.message }}</label>
                                    </template>
                                    <template v-else>
                                        <button class="btn btn-primary" @click="botTicketsPopupMethod(item.ticket_number)">Update</button>
                                        <router-link :to="{name:'supportWorkspace'}" class="btn btn-primary ml-2">
                                            <i class="fa fa-commenting" aria-hidden="true"></i>
                                        </router-link>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="8" class="text-center">You don't have any tickets.</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="fixloader" v-else>
                        <div class="spinner spinner-1"></div>
                    </div>
                </div>
            </div>
        </div>
        <close-ticket-popup v-if="botTicketsPopup" :deleteTicketId="deleteTicketId"></close-ticket-popup>
    </section>
</template>

<script>
/*eslint-disable */
import closeTicketPopup from "@/components/botTickets/closeTicketPopup.vue";
import { bus } from '@/main';
import { mapGetters } from 'vuex';
export default {
    name: 'bot-tickets',
    components: {
        'close-ticket-popup': closeTicketPopup
    },
    props: [],
    data() {
        return {
            botTickets: null,
            botTicketResults: [],
            botTicketsPopup: false,
            deleteTicketId: ''
        }
    },
    computed: {
        ...mapGetters([
            'botTicketListGetters',
        ]),
        botTicketList() {
            this.botTickets = this.$store.getters.botTicketListGetters.data;
            return;
        },
        setInitialStatus() {
            if (this.botTickets) {
                this.botTicketResults = this.botTickets.results;
            }
            return;
        },
    },
    mounted() {
        bus.$on('botTicketsPopupBus', (data) => {
            this.botTicketsPopup = data;
        })
        this.botTicketList;
        this.setInitialStatus;
    },
    methods: {
        botTicketsPopupMethod(ID) {
            this.botTicketsPopup = true;
            this.deleteTicketId = ID;
        }
    },
    watch: {
        botTicketList() {
            return this.$store.getters.botTicketListGetters;
        },
        setInitialStatus() {
            if (this.botTickets) {
                this.botTicketResults = this.botTickets.results;
            }
            return;
        },
    }
}

</script>

<style lang="scss" scoped>
.bot_tickets_table {
    color: #ffffff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;

    .top_brd {
        border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    .main_heading {
        color: #ffffff;
        font-size: 24px;
        text-transform: uppercase;
        font-weight: bold;
        margin: 0px;
    }

    .btn-primary {
        cursor: pointer;
        box-shadow: none !important;
        background: rgba(255, 255, 255, 0.12);
        color: #ffffff;
        border: none;
        border-radius: 3px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        font-size: 16px;
        padding: 4px 10px;

        &:hover {
            background: #87cefa !important;
            color: #000 !important;
            border-color: #87cefa !important;
        }
    }

    .bot_tickets_list {
        .table {
            margin-bottom: 0;
            letter-spacing: 0.5px;
            color: #ffffff;
            border-collapse: separate;
            border-spacing: 0 3px;

            >thead>tr {
                background: rgba(228, 233, 237, .1);
                align-items: end;
            }

            >thead tr {
                align-items: end;
            }

            >thead th {
                border-bottom: 0;
                font-size: 19px;
                padding: 10px 8px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                text-transform: uppercase;
                border-top: 0px;
                transition: all ease 0.5s;
                -webkit-transition: all ease 0.5s;
                -moz-transition: all ease 0.5s;
                color: #87cefa;
                word-spacing: 5px;
            }

            >thead .empty_cell th {
                padding: 0px !important;
                background: none !important;
            }

            >tbody tr td {
                color: #ffffff;
                vertical-align: top;
                padding: 20px 8px;
                font-size: 20px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                transition: all ease 0.5s;
                -webkit-transition: all ease 0.5s;
                -moz-transition: all ease 0.5s;
                border-top: 0px;
                background: rgba(228, 233, 237, .1);

                .badge {
                    font-weight: normal;
                    text-transform: capitalize;
                    font-size: 16px;
                }

                .btn {
                    box-shadow: none !important;
                    border: none !important;
                }
            }

            a:hover {
                text-decoration: none;
            }
        }
    }
}
</style>